// `value` is persisted on PostCollection and must remain stable.
// `label` is presentation copy and may be changed without migrating stored data.
export const CATALOGUE_SECTION_OPTIONS = Object.freeze([
  { value: "careers", label: "Careers" },
  { value: "technology_ai", label: "Technology & AI" },
  { value: "skills_practice", label: "Skills & Practice" },
  { value: "business_management", label: "Business & Management" },
  { value: "finance_economics", label: "Finance & Economics" },
  { value: "markets", label: "Markets" },
  { value: "industry_sector", label: "Industry & Sector" },
  { value: "thinking_method", label: "Thinking & Method" },
  { value: "academic", label: "Academic" },
]);

export const CATALOGUE_SECTION_CODES = Object.freeze(
  CATALOGUE_SECTION_OPTIONS.map(option => option.value)
);
